// extracted by mini-css-extract-plugin
export default {"editorContainer":"style_editorContainer__1Bzfe","docPopup":"style_docPopup__gdtGl","docScroll":"style_docScroll__wrtjS"};